import { Card, Flex, Spin, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import {ArrowLeftOutlined} from '@ant-design/icons';
import { useStore } from "../../../root-store-context";
import { useSupersetDashboard } from "../../../hooks/useSupersetDashboard";
import ReportError from "./ReportError";

const ViolationChartReport = observer(() => {

    const { reportStore } = useStore();
    const { isLoading, loadError } = useSupersetDashboard(reportStore.ViolationChartGUID, "BV_ViolationChart");

    return <>
            <Flex vertical={true} gap={10}>
            <Link to="/BoardVue/Reports" style={{ marginLeft: 10 }}><ArrowLeftOutlined /> Back</Link>
                <Card title={<Typography.Title level={5} style={{margin:0}}><b>Violation Chart</b></Typography.Title>}>
                    {/* Kept mounted even while hidden: embedDashboard resolves this node by
                        id from an effect, so it has to exist before the effect runs. */}
                    <div id="BV_ViolationChart" className="reportIframe" hidden={!!loadError}></div>
                    {isLoading ? <>
                        <Flex gap="small" vertical>
                            <Spin/>
                        </Flex>
                    </>: <></>}
                    {!isLoading && loadError ? <ReportError message={loadError} /> : <></>}
                </Card>
            </Flex>
    </>
})

export default ViolationChartReport
